
<div class="radio-group">
  <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
  <mat-radio-group 
    [formControl]="control">
    @for (option of options; track option.value) {
      <div>
        <mat-radio-button [value]="option.value">
          {{ option.label }}
        </mat-radio-button>
      </div>
    }
  </mat-radio-group>
  @if (showError && errorMessages.length) {
    @for (msg of errorMessages; track msg) {
      <mat-error>{{ msg }}</mat-error>
    }
  }
</div>
